import { FormlyFieldConfig } from '@ngx-formly/core';

export const FORM_FIELD_HORIZONTAL_WRAPPER = 'form-field-horizontal';

export function hasFormFieldHorizontalWrapper(field?: FormlyFieldConfig): boolean
{
  return !!field?.wrappers?.includes(FORM_FIELD_HORIZONTAL_WRAPPER);
}
